import React, { useState, useContext } from "react";
import { Row, Col, Form, Card, Button } from "react-bootstrap";
import bg1 from "./Images/bg1.jpg";
import bg3 from "./Images/bg3.jpeg";
import { Store } from "react-notifications-component";
import { faKey, faUserAlt } from "@fortawesome/fontawesome-free-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import Cookies from "universal-cookie";
import menuIcon from "./Images/menuIcon.png";
import PermissionContext from "../../Store/permission-context";
import classes from "./LoginPage.module.css";
const LoginPage = () => {
  var CryptoJS = require("crypto-js");
  const PCtx = useContext(PermissionContext);
  const [Username, setUsername] = useState("");
  const [Gateway, setGateway] = useState("");
  const [AxiosError, setAxiosError] = useState("");
  const [LoginOrMenu, setLoginOrMenu] = useState(true);
  const cookies = new Cookies();
  let ConnectionCount = 0;
  const getLoginDetails = async (e) => {
    e.preventDefault();
    let logindetails = { Username: Username, Gateway: Gateway };
    console.log(logindetails);
    let CheckLogin = await PCtx.connectAxios("getaccess.php", logindetails);
    console.log(CheckLogin);
    if (CheckLogin) {
      if (!CheckLogin.Scrambled.includes("Disallowed")) {
        let Scramb = CheckLogin.Scrambled;
        let Surname = CheckLogin.Surname;
        let Firstname = CheckLogin.Firstname;
        let Middlename = CheckLogin.Middlename;
        CryptoJS.AES.encrypt(Gateway, "143tonybridget").toString();
        let NS = CryptoJS.AES.encrypt(
          CheckLogin.Ns,
          "143tonybridget",
        ).toString();
        let MR = CryptoJS.AES.encrypt(
          CheckLogin.Mr,
          "143tonybridget",
        ).toString();
        let SI = CryptoJS.AES.encrypt(
          CheckLogin.Si,
          "143tonybridget",
        ).toString();
        let CP = CryptoJS.AES.encrypt(
          CheckLogin.Cp,
          "143tonybridget",
        ).toString();
        let ASt = CryptoJS.AES.encrypt(
          CheckLogin.ASt,
          "143tonybridget",
        ).toString();
        let VS = CryptoJS.AES.encrypt(
          CheckLogin.Vs,
          "143tonybridget",
        ).toString();
        let CPW = CryptoJS.AES.encrypt(
          CheckLogin.CPw,
          "143tonybridget",
        ).toString();
        let SP = CryptoJS.AES.encrypt(
          CheckLogin.Sp,
          "143tonybridget",
        ).toString();
        let SR = CryptoJS.AES.encrypt(
          CheckLogin.Sr,
          "143tonybridget",
        ).toString();
        let GS = CryptoJS.AES.encrypt(
          CheckLogin.Gs,
          "143tonybridget",
        ).toString();
        let IV = CryptoJS.AES.encrypt(
          CheckLogin.Iv,
          "143tonybridget",
        ).toString();
        let CR = CryptoJS.AES.encrypt(
          CheckLogin.Cr,
          "143tonybridget",
        ).toString();
        let VD = CryptoJS.AES.encrypt(
          CheckLogin.Vd,
          "143tonybridget",
        ).toString();
        let CF = CryptoJS.AES.encrypt(
          CheckLogin.Cf,
          "143tonybridget",
        ).toString();
        let GH = CryptoJS.AES.encrypt(
          CheckLogin.Gh,
          "143tonybridget",
        ).toString();
        let US = CryptoJS.AES.encrypt(
          CheckLogin.Us,
          "143tonybridget",
        ).toString();

        let Fullname = Surname + " " + Firstname + " " + Middlename.charAt(0);
        let LastLogin = CheckLogin.LastLogin;
        let Category = CheckLogin.Category;
        let Scrambled = Scramb.replace(/\s/g, "");
        // To decrypt the values sent from the server
        var bytes = CryptoJS.AES.decrypt(Scrambled, "143tonybridget");
        var Allowance = bytes.toString(CryptoJS.enc.Utf8);
        if (Gateway === Allowance) {
          let d = new Date();
          d.setTime(d.getTime() + 720 * 60 * 1000);
          cookies.set("this_staff", Fullname, {
            path: "/",
            expires: d,
          });
          cookies.set("userid", Username, { path: "/", expires: d });
          cookies.set("logged", true, { path: "/", expires: d });
          cookies.set("NS", NS, { path: "/", expires: d });
          cookies.set("MR", MR, { path: "/", expires: d });
          cookies.set("SI", SI, { path: "/", expires: d });
          cookies.set("CP", CP, { path: "/", expires: d });
          cookies.set("ASt", ASt, { path: "/", expires: d });
          cookies.set("VS", VS, { path: "/", expires: d });
          cookies.set("CPw", CPW, { path: "/", expires: d });
          cookies.set("SP", SP, { path: "/", expires: d });
          cookies.set("SR", SR, { path: "/", expires: d });
          cookies.set("GS", GS, { path: "/", expires: d });
          cookies.set("IV", IV, { path: "/", expires: d });
          cookies.set("CR", CR, { path: "/", expires: d });
          cookies.set("VD", VD, { path: "/", expires: d });
          cookies.set("CF", CF, { path: "/", expires: d });
          cookies.set("GH", GH, { path: "/", expires: d });
          cookies.set("US", US, { path: "/", expires: d });
          const Response = PCtx.connectAxios("savelastlogin.php", Username);
          PCtx.GetCookiesValue();
          PCtx.displayAlert(
            "SUCCESS",
            "Welcome " +
              Fullname +
              ", Your last login date and time was " +
              LastLogin +
              ". Please select a Menu.",
            "success",
          );
        } else {
          PCtx.displayAlert(
            "ERROR",
            "Username and Password is Incorrect. Please check and try again.",
            "danger",
          );
        }
      } else {
        PCtx.displayAlert(
          "ERROR",
          "Username and Password is Incorrect. Please check and try again.",
          "danger",
        );
      }
    } else {
      PCtx.displayAlert(
        "ERROR IN CONNECTION",
        "There is an error in connecting to the server, Please check your network or call on network administrator",
        "danger",
      );
    }
  };

  return (
    <Row>
      <Col
        md={7}
        sm={12}
        xs={12}
        className="p-0 m-0 d-none d-md-block d-lg-block"
      >
        <img src={bg3} alt="image2" height="450" className="w-100 m-0" />
      </Col>
      <Col
        md={5}
        sm={12}
        xs={12}
        className="p-0 m-0"
        style={{
          backgroundImage: `url(${bg1})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "450px",
        }}
      >
        <Row className="justify-content-around align-items-center h-100">
          <Col md={8} sm={12} xs={12}>
            <Card style={{ backgroundColor: "rgba(255, 255, 255, 0.5) " }}>
              <Card.Body>
                <h2
                  className="h2 text-center"
                  style={{
                    fontFamily: "Times New Roman",
                    marginTop: "20px",
                  }}
                >
                  WELCOME TO APPLAUSE BUSMAS!
                </h2>
                <h6 className="text-center">
                  Please login with your Username and Password
                </h6>
                <hr />
                <Form onSubmit={getLoginDetails}>
                  <Row className="justify-content-around align-items-center">
                    <Col md={12} sm={12} xs={12} className={classes.loginCol}>
                      <div
                        className="mx-md-3 mx-xs-2 mx-sm-2 mt-2 p-md-4 p-sm-4 p-xs-4 "
                        style={{
                          mozBoxShadow: "10px 10px 5px rgba(68, 68, 68, 0.6)",
                          webkitBoxShadow:
                            "10px 10px 5px rgba(68, 68, 68, 0.6)",
                          boxShadow: "10px 10px 5px rgba(68, 68, 68, 0.6)",
                        }}
                      >
                        <div
                          className="input-group"
                          style={{ boxShadow: "2px 2px #b1b1b1" }}
                        >
                          <div className="input-group-prepend">
                            <span
                              id="basic-addon"
                              className={`${
                                classes.AllBgColor
                              } ${"input-group-text"}`}
                            >
                              <FontAwesomeIcon
                                icon={faUserAlt}
                                style={{ color: "white" }}
                              />
                            </span>
                          </div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Username?"
                            name="Username"
                            aria-label="Username"
                            onChange={(e) => setUsername(e.target.value)}
                            required={true}
                            aria-describedby="basic-addon"
                            style={{ borderRadius: "0px" }}
                          />
                        </div>
                        <div
                          className="input-group mt-3"
                          style={{ boxShadow: "2px 2px #b1b1b1" }}
                        >
                          <div className="input-group-prepend">
                            <span
                              id="basic-addon"
                              className={`${
                                classes.AllBgColor
                              } ${"input-group-text"}`}
                            >
                              <FontAwesomeIcon
                                icon={faKey}
                                style={{ color: "white" }}
                              />
                            </span>
                          </div>
                          <input
                            type="password"
                            className="form-control"
                            name="gateway"
                            placeholder="Password"
                            aria-label="Password"
                            onChange={(e) => setGateway(e.target.value)}
                            aria-describedby="basic-addon"
                            required={true}
                            style={{ borderRadius: "0px" }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col
                      md={10}
                      sm={11}
                      xs={11}
                      style={{ textAlign: "right", marginTop: "10px" }}
                    >
                      <Button
                        type="submit"
                        className="btn btn-danger"
                        variant="danger"
                        style={{ backgroundColor: "brown" }}
                      >
                        Login
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LoginPage;
